import { render, staticRenderFns } from "./public-red-chirp-provide-secret.vue?vue&type=template&id=3d52e737&scoped=true&"
import script from "./public-red-chirp-provide-secret.vue?vue&type=script&lang=js&"
export * from "./public-red-chirp-provide-secret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52e737",
  null
  
)

export default component.exports